import { render, staticRenderFns } from "./highSeas.pug?vue&type=template&id=138a49cf&scoped=true&lang=pug&"
import script from "./highSeas.ts?vue&type=script&lang=ts&"
export * from "./highSeas.ts?vue&type=script&lang=ts&"
import style0 from "./highSeas.styl?vue&type=style&index=0&id=138a49cf&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a49cf",
  null
  
)

export default component.exports